var map = {
	"./left-bach.png": "b9cd",
	"./left-flower.png": "63de",
	"./mikao.jpg": "f8af",
	"./refle-left.png": "a22c",
	"./refle-right.png": "b93c",
	"./reiki.png": "d90b",
	"./right-bach.png": "29cc",
	"./right-flower.png": "7fac",
	"./see_wallpaper.jpg": "713c",
	"./shiatsu.png": "2974",
	"./wallpaper2.jpg": "fc8c",
	"./wallpaper3.jpg": "d65c",
	"./wallpaper4.jpg": "a304",
	"./wallpaper6.jpg": "3eef",
	"./wallpaper_contact.jpg": "6443",
	"./wallpaper_lahochi.jpg": "c414",
	"./wallpaper_reiki.jpg": "e23e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "77da";